export namespace Locale {
  export class Enum {
    static readonly BR = new Enum('pt-BR', 'BRL', 'R$')
    static readonly US = new Enum('en-US', 'USD', '$')

    private constructor(
      public readonly value: string,
      public readonly currency: string,
      public readonly currencySymbol: string
    ) {}
  }
}
